import pre from './pre';
import cart from './cart.vue';
import config from './config/index.vue';
import addon from './addon.vue';

export default {
  pre,
  components: {
    config,
    cart,
    addon,
  },
};
